import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { ReactComponent as ArrowIcon } from './../assets/icons/ArrowIcon.svg';
import { formatDate } from './../utils/date';
import cutting_mat from './../assets/images/cutting_mat.png';
import { ExternalLink, FadeInAnimation } from './../components';

const CardContent = ({ project }) => {
  // Format date safely with fallback
  const formattedDate = formatDate(project?.date);

  return (
    <div className="relative flex flex-col justify-between h-full transition-opacity duration-300 opacity-100 md:group-hover:opacity-0">
      <div className="flex flex-row justify-between w-full">
        {/*
        <div className="flex content-center justify-center px-3 py-2 mx-5 my-5 text-sm border shadow-lg bg-opacity-90 rounded-2xl border-neutral-100 bg-neutral-700 text-neutral-100">
          {project.genre}
        </div>
        */}
      </div>
      <div className="flex flex-row justify-between w-full">
        <div className="flex flex-col items-start mx-5 my-4">
          <h3 className="font-semibold text-neutral-200 text-md">{project.title}</h3>
          {formattedDate && (
            <h3 className="text-sm font-normal capitalize text-neutral-300/90">
              {formattedDate}
            </h3>
          )}
        </div>
        <div className="flex-col justify-center hidden px-5 py-4 text-sm text-neutral-200 sm:flex">
          <ExternalLink title={'View Project'} isUnderline={true} />
        </div>
      </div>
    </div>
  );
};

const ProjectCard = ({ project }) => {
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleMouseMove = (event) => {
    setTooltipPosition({ x: event.clientX + 12, y: event.clientY + 12 });
  };

  if (!project && !project?.slug) return null;

  return (
    <>
      <FadeInAnimation>
        <div
          className="relative aspect-[4/3] overflow-visible rounded-2xl border border-foreground bg-background shadow-md"
          onMouseEnter={() => setIsTooltipVisible(true)}
          onMouseMove={handleMouseMove}
          onMouseLeave={() => setIsTooltipVisible(false)}
        >
          <a
            href={`/project/${project.slug}`}
            className="block h-full overflow-hidden rounded-2xl group"
          >
            <div
              className="relative flex flex-col justify-between h-full overflow-hidden transition-transform duration-700 ease-out bg-center bg-cover rounded-2xl md:group-hover:scale-110"
              style={{
                backgroundImage: project.thumbnail
                  ? `url(${project.thumbnail})`
                  : `url(${cutting_mat})`,
              }}
            >
            <div className="absolute inset-0 transition-opacity duration-300 opacity-100 bg-gradient-to-t from-black/70 via-black/20 to-transparent md:group-hover:opacity-0" />
              <CardContent project={project} />
            </div>
          </a>
        </div>
      </FadeInAnimation>

      {/* Render Tooltip via Portal directly onto body */}
      {isTooltipVisible &&
        typeof document !== 'undefined' &&
        createPortal(
          <div
            className="fixed z-[9999] whitespace-nowrap rounded-2xl flex items-center gap-1 bg-secondary px-4 py-2 text-sm font-medium border border-neutral-100 text-neutral-100 shadow-lg pointer-events-none tracking-wide"
            style={{ left: tooltipPosition.x, top: tooltipPosition.y }}
          >
            <span>{project.title}</span>
            <ArrowIcon className="w-5 h-5" />
          </div>,
          document.body,
        )}
    </>
  );
};

export default ProjectCard;
